<template>
    <div class="has-text-centered m-md p-md" v-if="application.application_complete && !application.accepted">
        <div class="application-status">
            Votre dossier a bien été envoyé. Vous allez recevoir une réponse
            par mail et sur votre espace personnel Diderot Max.
        </div>

    </div>
</template>

<script>
    import {mapActions} from 'vuex'

    export default {
        data () {
            return {
            }
        },
        props: {
            candidate: { type: Object }
        },
        computed: {
            application () {
                return this.candidate.applications
            }
        },
        methods: {
            ...mapActions({
                sendProcess: 'candidate/saveProcessMode'
            }),
            edit: function () {
                this.$emit('edit')
            }
        }
    }
</script>

<style scoped>

    .radio-group .choice {
        width: 100%;
        height: auto;
        margin-bottom: 1rem;
    }

    .radio-group input[type="radio"]:checked + .choice {
        background-color: #0f1e44;
        color: white;
    }

    .radio-group input[type="radio"]:checked + .choice strong {
        color: white;
    }
</style>
